import React, { useEffect } from 'react'; 
import './faq.css'


function Faq(props) {
    window.scrollTo(0, 0) 
    document.title = "Nivesh Karma - FAQ";

    useEffect(() => {
    }, [])
    return (
        <div className="Disclaimer commonContainer" >
            <div className="AboutUs-container" style={{ backgroundColor: "white" }}>
            <h2>FAQ</h2>
                <p><b>1.	What types of financial data can I access through your API? </b><br/>
                    Our API provides access to a wide range of financial data, including Profit & Loss statements, Balance Sheets, Cash Flow statements, financial ratios, commodity price trends, shareholding patterns, and more for 4000+ companies listed on BSE and NSE. You can retrieve historical data, real-time updates, and comprehensive stock information.
            </p>
                <p><b>2.	How do I get started with your API?  </b><br />
                Getting started is simple! Sign up on our website, and you'll receive your API key instantly. With this key, you can start integrating our financial data into your applications immediately. We also provide detailed documentation and sample data for easy integration. 
            </p>
            <p>
                    <b>3.	Is there a free trial available? </b><br />
                Yes, we offer a free access to 2 companies. This includes sample financial data for HDFC Bank and ITC, enabling you to test our API's functionality before committing to a subscription.
            </p>
            <p>
                    <b> 4.	How frequently is the financial data updated? </b><br />
                Our financial data is updated within a day after company publishes its financial results. This ensures that you have access to the most current information available, whether you're tracking stock prices, company financials, or shareholding patterns.  
            </p>
            <p>
                    <b>5.	How secure is the data provided through your API?</b><br />
                Security is our top priority. Our API employs industry-standard encryption protocols to ensure that your data transactions are secure. Additionally, we provide secure authentication methods, such as API keys and tokens, to protect your access.
            </p>
            <p>
                    <b>6.	What support options are available if I need help with integration?</b><br />
                We offer comprehensive support to all our users via email channel (niveshkarma@gmail.com), including detailed documentation, sample code, and assistance with any integration challenges. For Business users, we provide tailored solutions and priority support to ensure smooth implementation. 
            </p>
            <p>
                    <b>7.	What industries or sectors do you cover in your financial data? </b><br />
                Our API covers a wide range of industries and sectors, including banking, IT, manufacturing, pharmaceuticals, FMCG, and more. You can filter and retrieve data based on specific sectors, making it easier to analyze industry trends and compare company performance within the same industry. 
            </p>
                <p>
                    <b>8.  Is there a refund policy if I'm not satisfied with the service? </b><br />
                    Currently, we do not offer refunds for subscriptions. However, we highly value your feedback and encourage you to share your experience with us so we can continue to improve our services. For more details, please refer to our terms and conditions.
                </p>
            </div>
        </div>
    );
}
export default Faq;